import Strf from "./Strf";

export default Strf;



// WEBPACK FOOTER //
// ./src/shared/components/Str.jsx